import { render } from "./Footer.vue?vue&type=template&id=600e895c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=600e895c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-600e895c"

export default script